<template>
  <iv-modal
    :title="modal.title"
    v-model="modal.shown"
    :transfer="false"
    :scrollable="true"
    :class-name="'vertical-center-modal'"
    :styles="style"
    @on-cancel="onCancel"
  >
    <section style="height: 500px;overflow: auto;position:relative;">
      <EmptyPanel :empty="sources.list.length <= 0" :loading="loader[OPERATION_LOG]"  />
      <div v-if="sources.list.length > 0">
        <iv-row type="flex" justify="center">
          <iv-col span="12">
            <template v-if="sources.list.length === 0">
              <p style="text-align: center">暂无数据</p>
            </template>
            <template v-else>
              <iv-Timeline>
                <iv-TimelineItem v-for="item in sources.list" :key="item.id">
                  <p>{{ item.operationTime | timesify }}</p>
                  <p><b>{{ item.operator }}</b></p>
                  <p><span slot="desc">{{ item.action }}<br/>{{ item.detail }}</span></p>
                </iv-TimelineItem>
              </iv-Timeline>
            </template>
          </iv-col>
        </iv-row>
      </div>
    </section>

    <footer slot="footer">
      <iv-button :loading="loader[OPERATION_LOG]" @click="refresh()">
        <iv-icon type="md-refresh" />
        <span>刷新</span>
      </iv-button>
      <iv-button type="primary" ghost :loading="loader[OPERATION_LOG]" @click="onCancel">知道了</iv-button>
    </footer>
  </iv-modal>
</template>

<script>
import OperationLogModel from "@/models/OperationLogModel";

import EmptyPanel from "@/components/EmptyPanel";

import ModelMixin from "@/mixins/Model.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";
import contact from "@/utils/contact";

const OPERATION_LOG = OperationLogModel.ModelName;

export default {
  name: "Logs",
  model: {
    prop: "shown",
    event: "shown",
  },
  mixins: [
    LoaderMixin(OPERATION_LOG),
    ModelMixin({
      contact,
      models: [OperationLogModel],
    }),
  ],
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    shown: Boolean
  },
  watch: {
    shown(val) {
      this.refresh();
      this.shown = val
      this.marginTop = document.body.scrollTop;
    },
  },
  data() {
    return {
      OPERATION_LOG,
      sources: {
        list: [],
      },
      options: {},
      modal: {
        shown: false,
        title: "操作日志",
      },
      conditions: {}
    };
  },
  methods: {
    async refresh(conditions=this.conditions) {
      const result = await this.$$fetch(OPERATION_LOG, { ...conditions });
      if (Error.isError(result)) return;
      this.sources.list = result.data;
    },
    onCancel() {
      this.modal.shown = false;
      this.$emit("shown", false);
    },
    show(params={}){
      this.modal.shown = true
      this.conditions = params
      this.refresh(params);
    },
    hide(){
      this.modal.shown = false
      this.$emit('hide', false)
      this.conditions = {}
    }
  },
  computed: {
    style() {
      return { marginTop: document.body.scrollTop || document.documentElement.scrollTop + "px" };
    },
  },
  components: {
    EmptyPanel
  }
};
</script>
